class AppHeaderBean {
  constructor(name, role, branch) {
    this.name = name;
    this.role = role;
    this.branch = branch;
  }
}

export default AppHeaderBean;
